<template>
  <div>
    <!-- //header -->
    <div class="header-bottom bg_red">
      <div class="container">
        <!--响应式菜单-->
        <nav class="navbar navbar-default" role="navigation">
          <div class="navbar-header">
            <button
              type="button"
              class="navbar-toggle"
              data-toggle="collapse"
              data-target="#menu"
              id="button1"
            >
              <span class="sr-only">展开导航</span>
              <span class="icon-bar" data-toggle="collapse"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <div class="logo">
              <!--            <h1><a class="navbar-brand" href="#"><span>A</span>irwork</a></h1>-->
              <h1>
                <a class="navbar-brand" href="#"
                  ><img :src="application.imageHost + logoList.logoPath"
                /></a>
              </h1>
            </div>
          </div>
          <div class="collapse navbar-collapse menuColor" id="menu">
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="1">
                <router-link :to="'/'">首页</router-link></el-menu-item
              >
              <el-submenu index="2">
                <template slot="title"
                  ><router-link :to="'/company?type=0'"
                    >公司概况</router-link
                  ></template
                >
                <el-menu-item index="2-1"
                  ><router-link :to="'/company?type=0'"
                    >公司介绍</router-link
                  ></el-menu-item
                >
                <el-menu-item index="2-2">
                  <router-link :to="'/company?type=1'"
                    >企业文化</router-link
                  ></el-menu-item
                >
                <el-menu-item index="2-3">
                  <router-link :to="'/company?type=2'"
                    >组织架构</router-link
                  ></el-menu-item
                >
                <el-menu-item index="2-4">
                  <router-link :to="'/company?type=3'"
                    >资质证书</router-link
                  ></el-menu-item
                >
              </el-submenu>

              <el-submenu index="3">
                <template slot="title"
                  ><router-link :to="'/product?type=0'"
                    >主营业务</router-link
                  ></template
                >
                <el-menu-item index="3-1">
                  <router-link :to="'/product?type=0'"
                    >信息化物联</router-link
                  ></el-menu-item
                >
                <el-menu-item index="3-2">
                  <router-link :to="'/product?type=1'"
                    >节能技术及产品</router-link
                  ></el-menu-item
                >
                <el-menu-item index="3-3">
                  <router-link :to="'/product?type=2'"
                    >环保产品开发和应用</router-link
                  ></el-menu-item
                >
                <el-menu-item index="3-4">
                  <router-link :to="'/product?type=3'"
                    >机电设备销售及服务</router-link
                  ></el-menu-item
                >
              </el-submenu>

              <el-submenu index="4">
                <template slot="title"
                  ><router-link :to="'/case?type=0'"
                    >工程案例</router-link
                  ></template
                >
                <el-menu-item index="4-1">
                  <router-link :to="'/case?type=0'"
                    >信息化物联</router-link
                  ></el-menu-item
                >
                <el-menu-item index="4-2">
                  <router-link :to="'/case?type=1'"
                    >节能技术及产品</router-link
                  ></el-menu-item
                >
                <el-menu-item index="4-3">
                  <router-link :to="'/case?type=2'"
                    >环保产品的应用</router-link
                  ></el-menu-item
                >
              </el-submenu>

              <el-menu-item index="5">
                <router-link :to="'/partner'"
                  >合作伙伴</router-link
                ></el-menu-item
              >
              <el-menu-item index="6"
                ><router-link :to="'/newsPage'"
                  >新闻资讯</router-link
                ></el-menu-item
              >
              <el-menu-item index="7"
                ><router-link :to="'/contact'"
                  >联系我们</router-link
                ></el-menu-item
              >
            </el-menu>
            <!-- <ul class="nav navbar-nav cl-effect-1 button_nav">
              <li v-for="(item, i) in menuList">
                <router-link :to="item.url">{{ item.name }}</router-link>
              </li>
            </ul> -->
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>
<style src="./header.css" scoped></style>
<script>
import mixins from "../../common/mixin";
import application from "../../common/application";
export default {
  name: "header",
  mixins: [mixins],
  data: () => ({
    application: application,
    menuList: [],
    logoList: {},
    activeIndex: "0",
    activeIndex2: "1",
  }),
  created() {
    let url = this.$route.fullPath;
    console.log("url" + url);
    if (url.indexOf("company") >= 0) {
      this.activeIndex = "2";
    } else if (url.indexOf("product") >= 0) {
      this.activeIndex = "3";
    } else if (url.indexOf("case") >= 0) {
      this.activeIndex = "4";
    } else if (url.indexOf("partner") >= 0) {
      this.activeIndex = "5";
    } else if (url.indexOf("newsPage") >= 0) {
      this.activeIndex = "6";
    } else if (url.indexOf("contact") >= 0) {
      this.activeIndex = "7";
    } else {
      this.activeIndex = "1";
    }
    this.handleTab();
    this.handleLogo();
    if (this.$route.path) {
    }
  },
  mounted() {
    $(function () {
      $(".button_nav").on("click", function () {
        $("#menu").removeClass("in");
      });
    });
  },
  methods: {
    toCompany() {
      alert(1);
    },
    toUrl(url) {
      this.$router.push(url);
      // this.$router.
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleTab() {
      this.request({
        url: "/web/menu/list",
        data: {
          pageIndex: 0,
          pageSize: 10,
        },
        success: (response) => {
          this.menuList = response.data.records;

          // console.log(this.menuList)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
    handleLogo() {
      this.request({
        url: "/web/introduce/detail",
        data: {
          id: 8,
        },
        success: (response) => {
          this.logoList = response.data;
          // console.log(this.menuList)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
  },
};
</script>

<style >
.el-menu-item a {
  color: #909399;
  font-size: 16px;
}
.header-bottom .el-submenu__title a {
  text-decoration: none;
  color: #909399;
  text-decoration: none;
}
.header-bottom .el-menu-item a {
  text-decoration: none;
}
.header-bottom .el-submenu__title a:hover {
  text-decoration: none;
  color: #337ab7;
}
.el-submenu .el-submenu__title {
  font-size: 16px;
}
.el-menu-item:hover a {
  color: #337ab7 !important;
}
.header-bottom .el-menu--horizontal {
  display: flex;
  justify-content: space-around;
  margin-left: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue